import React from 'react';
import { IconProps } from '../Icons.interface';

export const VimeoOutlineIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19px"
    height="19px"
    viewBox="0 0 20 20"
    className={className}
  >
    <g>
      <path
        fill="currentColor"
        d="M 10 1.667969 C 14.59375 1.667969 18.332031 5.40625 18.332031 10 C 18.332031 14.59375 14.59375 18.332031 10 18.332031 C 5.40625 18.332031 1.667969 14.59375 1.667969 10 C 1.667969 5.40625 5.40625 1.667969 10 1.667969 Z M 10 0 C 4.476562 0 0 4.476562 0 10 C 0 15.523438 4.476562 20 10 20 C 15.523438 20 20 15.523438 20 10 C 20 4.476562 15.523438 0 10 0 Z M 14.53125 9.867188 C 13.511719 12.039062 11.058594 15 9.503906 15 C 7.972656 15 7.753906 11.738281 6.917969 9.566406 C 6.507812 8.496094 6.242188 8.742188 5.472656 9.28125 L 5 8.675781 C 6.125 7.6875 7.25 6.539062 7.941406 6.476562 C 8.71875 6.398438 9.199219 6.933594 9.378906 8.070312 C 9.613281 9.570312 9.945312 11.890625 10.523438 11.890625 C 10.972656 11.890625 12.082031 10.050781 12.136719 9.390625 C 12.238281 8.425781 11.425781 8.394531 10.726562 8.695312 C 11.839844 5.050781 16.472656 5.722656 14.53125 9.867188 Z M 14.53125 9.867188 "
      />
    </g>
  </svg>
);
